"use strict";
module.exports = require('../../module.compiled').vendored['react-rsc'].ReactServerDOMWebpackStatic;

//# sourceMappingURL=react-server-dom-webpack-static.js.map